// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"CustomToggle_toggleWrapper__5psuY","toggleBtn":"CustomToggle_toggleBtn__Oa4gX","toggleBtnActive":"CustomToggle_toggleBtnActive__xPNsE"};